// Context
import { useState } from "react";
import Modal from "../common/Modal";
import ModalTicketList from "./ModalTicketList";
import ModalTicketDetail from "./ModalTicketDetail";
import ModalTicketCreate from "./ModalTicketCreate";
import { useTranslation } from "react-i18next";

function ModalTicket({ close, show, initialCreate, initialChatId }) {
  const { t } = useTranslation();
  const [selectedTicket, setSelectedTicket] = useState();
  const [createTicket, setCreateTicket] = useState(initialCreate || false);

  return (
    <Modal
      show={show}
      close={close}
      size="medium"
      title={
        createTicket ? (
          <div className="vertical-align-mobile">
            <button className="link btn-round mr-10" onClick={() => setCreateTicket()}>
              <i className="notranslate material-icons mr-10">arrow_back_ios_new</i>
            </button>
            {t("tickets.modal.createTicket")}
          </div>
        ) : selectedTicket ? (
          <div className="vertical-align-mobile">
            <button className="link btn-round mr-10" onClick={() => setSelectedTicket()}>
              <i className="notranslate material-icons mr-10">arrow_back_ios_new</i>
            </button>
            {t("tickets.modal.viewTicket")}
          </div>
        ) : (
          t("tickets.modal.myTickets")
        )
      }
      className={"ticket-modal"}
    >
      {createTicket ? (
        <ModalTicketCreate close={() => setCreateTicket(false)} initialChatId={initialChatId}></ModalTicketCreate>
      ) : !selectedTicket ? (
        <ModalTicketList setSelectedTicket={setSelectedTicket} setCreateTicket={setCreateTicket}></ModalTicketList>
      ) : (
        <ModalTicketDetail setSelectedTicket={setSelectedTicket} ticket={selectedTicket}></ModalTicketDetail>
      )}
    </Modal>
  );
}

export default ModalTicket;
